import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const StarIcon = ({ size = 12, filled = true, ...props }: IconProps & { filled?: boolean }) => (
  <svg {...iconBaseProps(size, props)} fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round">
    <path d="M12 2.5l2.9 6.1 6.6 0.9-4.8 4.7 1.2 6.6L12 17.7l-5.9 3.1 1.2-6.6L2.5 9.5l6.6-0.9L12 2.5z" />
  </svg>
)
